import { Button, Card, Typography } from "~/common/mui";
import { ELEVATION_1 } from "~/common/components/icon/Elevation";
import { C_SURFACE } from "~/common/components/icon/Colors";
import { Trans, useTranslation } from "react-i18next";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { type PriceData } from "~/domains/pricing/types/PriceData";
import { Snackbar } from "~/common/mui/Snackbar/Snackbar";
import { formatCurrency } from "~/common/utils/currencyFormatter";

export interface ATCBarProps {
  selectedLineItems: number;
  selectedQuantity: number;
  totalPrice: PriceData;
  loading?: boolean;
  onAddToCart: () => void;
}

export const ATCBar = ({ selectedLineItems, selectedQuantity, totalPrice, loading, onAddToCart }: ATCBarProps) => {
  const { t } = useTranslation();

  return (
    <Snackbar open={true}>
      <Card
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: 1,
          gap: 3,
          borderRadius: 28,
          boxShadow: ELEVATION_1,
          background: C_SURFACE,
        }}
      >
        <Typography>
          <Trans i18nKey={"feature.order.atcBar.selected"} count={selectedLineItems}>
            <strong>{{ count: selectedLineItems }}</strong> Selected line
          </Trans>
        </Typography>
        <Typography>
          <Trans i18nKey={"feature.order.atcBar.quantity"} count={selectedQuantity}>
            <strong>{{ count: selectedQuantity }}</strong> Pcs.
          </Trans>
        </Typography>
        <Typography sx={{ fontWeight: "bold" }}>
          {formatCurrency(totalPrice?.value, totalPrice?.currencyIso)}
        </Typography>
        <Button
          data-test-id={"add-all-to-cart"}
          startIcon={<ShoppingCartOutlinedIcon />}
          loading={loading}
          onClick={onAddToCart}
        >
          {t("orderQuotePage.ATCBar.btn")}
        </Button>
      </Card>
    </Snackbar>
  );
};
